import React, { useState } from 'react';
import classnames from 'classnames';
import { titleize } from 'underscore.string';
import Badge from 'components/v2/Badge';
import RefreshIcon from 'components/v2/icons/RefreshIcon';
import Tooltip from 'components/ui/Tooltip';
import usePoller from 'hooks/usePoller';
import { getBillingStatusBadgeColor, } from 'helpers/status-bar';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { evaluateBillingStatus } from 'utils/ShipmentWebAPIUtils';
export default function BillingStatus({ shipment, order, t, isOrderContext }) {
    var _a;
    if (!isIntermodalShipmentType(shipment) && !isOrderContext) {
        return null;
    }
    const [disabled, setDisabled] = useState(false);
    const { resetTimer } = usePoller(() => setDisabled(false));
    const handleClick = async () => {
        var _a;
        const shipmentId = (_a = shipment === null || shipment === void 0 ? void 0 : shipment._id) !== null && _a !== void 0 ? _a : shipment;
        if (!disabled && shipmentId) {
            await evaluateBillingStatus([shipmentId]);
            setDisabled(true);
            resetTimer();
        }
    };
    let billingStatus = (_a = shipment === null || shipment === void 0 ? void 0 : shipment.billing_status) !== null && _a !== void 0 ? _a : order === null || order === void 0 ? void 0 : order.billing_status;
    if (!billingStatus) {
        return null;
    }
    const renderIcon = () => {
        const tooltip = disabled
            ? 'BILLING_STATUS_REFRESH_DISABLED'
            : 'BILLING_STATUS_REFRESH_ENABLED';
        return ((React.createElement(Tooltip, { dataTestId: "Tooltip-1dd2065b", id: "tooltip-master-ref", content: t(tooltip), position: "top" },
            React.createElement("div", { "data-testid": "div-dc6979d4", className: "my-auto", onClick: handleClick },
                React.createElement(RefreshIcon, { className: classnames({ disabled, 'w-4': true, 'h-4': true }) })))));
    };
    return ((React.createElement("div", { "data-testid": "div-c1280eb9", className: "flex" },
        React.createElement(Badge, { dataTestId: "Badge-cd8ed2f4", className: isOrderContext ? '' : 'mx-2', color: getBillingStatusBadgeColor(billingStatus) }, titleize(t(billingStatus === null || billingStatus === void 0 ? void 0 : billingStatus.toUpperCase()))),
        renderIcon())));
}
